import { FC, FormEvent, useCallback, useState } from 'react';
import { useNavigation } from '@utilities/hooks';
import { NavigationPathsEnum } from '@utilities/enums';
import { sendOtp } from '@services/admin.service';

export const Login: FC = () => {
    const { navigateTo } = useNavigation();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = useCallback(async (e: FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            await sendOtp(email);
            // Stocker l'email temporairement pour la page OTP
            sessionStorage.setItem('otp_email', email);
            navigateTo(NavigationPathsEnum.OTP_VERIFICATION);
        } catch (err: any) {
            setError(err.message || 'Une erreur est survenue');
        } finally {
            setLoading(false);
        }
    }, [email, navigateTo]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-base-200">
            <div className="card w-full max-w-md bg-base-100 shadow-xl">
                <div className="card-body">
                    <h2 className="card-title text-2xl font-bold mb-2">Administration</h2>
                    <p className="text-base-content/60 mb-6">
                        Entrez votre adresse email pour recevoir un code de vérification.
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="form-control w-full mb-4">
                            <label className="label">
                                <span className="label-text">Adresse email</span>
                            </label>
                            <input
                                type="email"
                                placeholder="admin@example.com"
                                className="input input-bordered w-full"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={loading}
                            />
                        </div>

                        {error && (
                            <div className="alert alert-error mb-4">
                                <span>{error}</span>
                            </div>
                        )}

                        <button
                            type="submit"
                            className={`btn btn-primary w-full ${loading ? 'loading' : ''}`}
                            disabled={loading || !email}
                        >
                            {loading ? 'Envoi en cours...' : 'Recevoir le code'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};
